<template>
    <div class="wf-bg" data-app>

        <div class="wf-container">
            <h1>Frieden?!</h1>

            <div class="wf-inner">
                <p>
                    Wie die Suche nach der Stecknadel im Heuhaufen – so gestaltet sich die Suche nach dem Frieden in
                    unserer aktuellen Welt. Gibt es angesichts des Hasses überhaupt noch einen Hoffnungsschimmer? Wie
                    kann Frieden dort einkehren, wo sich jetzt bis auf die Zähne bewaffnete Feinde gegenüberstehen? Gibt
                    es einen Lichtblick?
                </p>
                <p>
                    Licht kommt von oben. Wenn wir all das menschengemachte Leid betrachten, dann liegt der Gedanke
                    nahe, dass es für Frieden auf der Welt tatsächlich ein Wunder von oben braucht. Wir bekommen unseren
                    „Friede – Freude – Eierkuchen“ nämlich nicht gebacken. Gott wäre dringend gefragt.
                    Kann es jedoch angesichts all des himmelschreienden Leids überhaupt einen Gott geben? Die Bibel
                    bejaht diese Frage und erzählt von einem Gott, der das Leid beenden will mit Leid vertraut ist und
                    das Rezept für Frieden kennt. Und es höchstpersönlich und ganz offen verkündet hat, sodass du es
                    jederzeit nachlesen kannst.
                </p>
                <h2>Lichtblick</h2>
                <p>
                    Laut den biblischen Berichten ist etwas geschehen, das für dich unglaublich klingen mag: Gott hat
                    dieser verzweifelten Welt einen Besuch abgestattet! Weihnachten erzählt davon, dass der Schöpfer
                    persönlich in die Welt des Leids und der Gewalt gekommen ist – geboren als kleines Baby in einem
                    Stall. Wenn dir das wie ein Märchen vorkommt, dann bleibe wegen unserer Friedensspur weiter dran.
                    Denn als erwachsener Mann sprach Jesus öffentlich davon, welche Schlüsselfaktoren es für den Frieden
                    braucht. Und die waren damals so revolutionär wie heute und sind historisch unübertroffen. Wir
                    greifen drei Aussagen heraus:
                </p>
                <p>
                    <cite>
                        „Liebt eure Feinde!“
                    </cite>
                    <cite>
                        „Seid barmherzig, geduldig und demütig!“
                    </cite>

                    <cite>
                        „Überwindet das Böse durch das Gute!“
                    </cite>
                </p>
                <p>
                    Die Worte von Jesus haben einen echten Lichtstrahl in unsere Welt gebracht. Liebe über Grenzen und
                    Sympathien hinweg. Wie würde eine Welt aussehen, in der das gelebt wird? Wie viele Kriege gäbe es
                    noch?
                </p>

                <h2> Mehr Licht in diese Welt bringen</h2>
                <p>
                    Jesu Worte kursieren nun schon seit zwei Jahrtausenden in der Welt – und stoßen größtenteils immer
                    noch auf taube Ohren. Woran liegt das? Vielleicht daran, dass sich jeder selbst der Nächste ist.
                    Dass wir im Grunde egoistisch und hartherzig sind und es leichter finden, uns zu rächen als zu
                    vergeben. Diese Haltung führt im Kleinen zu Rosenkriegen und im Großen zu Weltkriegen. Wie kann das
                    ein Ende haben?
                </p>
                <p>
                    Zunächst lädt Jesus uns dazu ein, selbst einen Unterschied zu machen. Wie bei der Klimakrise können
                    auch wir nicht das weltweite Problem auf einmal lösen, aber jeder kann seinen Teil dazu beitragen.
                    Wo immer die radikalen Maßstäbe der Nächsten- & Feindesliebe von Jesus heute gelebt werden, scheint
                    Licht in diese finstere Welt.
                </p>
                <p>
                <h2>Nicht hier, aber doch: Frieden wird kommen</h2>
                <p>
                    Allerdings sagt Gott auch klar in seinem Wort, dass diese Welt schon so verdorben ist, dass etwas
                    Neues her muss. Das Problem mit dem Frieden ist nicht die Erde an sich, sondern wir Menschen – und
                    nicht alle sind bereit, sich zu ändern. Deshalb hat er einen Plan: eine neue Welt. Eine Welt ohne
                    Leid, Hass und Krieg. Klarerweise können wir nicht in unserem jetzigen Zustand in diese Welt, sonst
                    würde es dort ja genauso weitergehen wie hier. Aus diesem Grund bietet Gott uns an, unser
                    fehlerhaftes Herz auszuwechseln gegen ein neues, vollkommenes. Das kann nur er uns geben. Er will
                    uns von allem Schmutz freimachen und unsere Fehler vergeben: Ein völliger Neuanfang.
                </p>
                <p>
                    Klingt das utopisch? Wir würden es auch nicht glauben, wenn Jesus es nicht selbst gesagt hätte und
                    wir nicht persönlich erlebt hätten, dass er uns in unserem Leben zur Vergebung und Feindesliebe
                    befähigt. Wir möchten dich einladen, dir selbst ein Bild davon zu machen, ob Jesus leere Worte
                    brachte, oder ob seine Einladung in die neue Welt genauso Hand und Fuß hat wie seine moralischen
                    Maßstäbe, die du im Neuen Testament kennenlernen kannst. Wenn du noch kein Neues Testament hast,
                    schenken wir dir gerne eines. Lerne dort den Friedensexperten kennen und wer weiß, vielleicht willst
                    und wirst auch du mit seiner Hilfe und Kraft ein lebendiger Baustein für mehr Frieden werden.
                </p>
                <div class="order-button-container">
                    <v-btn class="modernButton wf-button" @click="openOrder">Kostenlos bestellen</v-btn>
                    <v-btn class="modernButton wf-button" to="/">Zu WERSGLAUBT.AT</v-btn>

                    <v-dialog v-model="order">
                        <UniversalOrder :active="order" @close="order = false"/>
                    </v-dialog>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Component from "vue-class-component";
import BasicComponent from "@/components/BasicComponent";
import UniversalOrder from "@/components/UniversalOrder.vue";

@Component({
    components: {UniversalOrder}
})
export default class Weihnachtsfriede extends BasicComponent {

    order = false;

    openOrder() {
        this.order = true;
    }

}
</script>

<style scoped lang="scss">
$wf-bg: rgb(45, 53, 72);
$wf-bright: rgb(224, 217, 189);

.wf-bg {
  background-image: url("../assets/weihnachtsfriede/wf-bg.jpg");
  background-size: cover;
  background-position: center;
  background-repeat: repeat-y;
  display: flex;
  justify-content: center;

  .wf-container {
    margin: 0 5vw;
    width: 90vw;
    max-width: 800px;
    display: inline-block;

    .wf-inner {
      box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.5);
      background: $wf-bright;
      padding: 2rem;
      margin-top: 2rem;
      margin-bottom: 5vw;

      text-align: justify;
      font-size: 1.2em;

      p {
        margin-bottom: 1rem;
      }
    }
  }
}

h1 {
  color: $wf-bright;
  margin-top: 2rem;
  font-size: 3em;
}

.order-button-container {
  display: flex;
  justify-content: center;
  margin-top: 1rem;
  flex-wrap: wrap;
}

cite {
  display: block;
  margin-bottom: 1rem;
  text-align: center;
  font-family: "Source Serif Pro", "Source Sans Pro", sans-serif;
  color: $wf-bg;
  font-size: 1.4em;
  font-weight: 600;
  font-style: normal;
}

.wf-button {
  background-color: rgb(168, 60, 63) !important;
  margin: 5px;
}
</style>
